import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class FleetService {
  apiUrl:any=environment.url.BASE_URL
  authUrl:any=environment.url.authUrl
  constructor(private http:HttpClient) { }

  getWordFileContent(filePath: string): Observable<string> {
    return this.http.get(filePath, { responseType: 'text' });
  }

  getAllFleetList() {
    return this.http.get(this.apiUrl + 'fleet')
  }

  getFleetOwner(id){
    return this.http.get(this.apiUrl + `fleet/owner/${id}`)
  }

getProviders(consumer: string): Observable<any> {
    const params = new HttpParams().set('consumer', consumer);
    return this.http.get(this.authUrl + `providers`,{ params });
  }

    addOem(fleetIdentifier: number, payload: any): Observable<any> {
    return this.http.put(`${this.apiUrl}fleet/${fleetIdentifier}`,payload);
  }
  addConsentForm(id:any,filePdf:any,pId:any) {
    let formdata = new FormData()
    // let a:any =new File([filePdf],'consentAgreement')
    // console.log(a,'cnsdlk');
    
    formdata.append('fleetId',id)
    formdata.append('file',filePdf)
    formdata.append('providerId',pId)
    // formdata.append('file',new File([filePdf],'consentAgreement'))
    return this.http.post(this.apiUrl + 'fleet/consent',formdata)
  }

  addFleetUser(body) {
    return this.http.post(this.apiUrl + 'user',body)
  }

  getFleetList() {
    return this.http.get(this.apiUrl + 'fleet/owner/')
  }

  fleetDetailById(id) {
    return this.http.get(this.apiUrl + 'fleet/'+id)
  }

  rejetConsent(id,pId) {
    let formdata = new FormData()
    formdata.append('fleetId',id)
    formdata.append('providerId',pId)
    return this.http.post(this.apiUrl + 'fleet/consent/reject',formdata)
  }

  updateFleet(id,data) {
    return this.http.put(this.apiUrl + `fleet/${id}`,data)
  }

  downloadConsentPdf(url:any) { 
    let param = new HttpParams().set('pdfUrl',url)
    return this.http.get(this.apiUrl + 'fleet/preSigned/',{params:param,responseType:'text'})
    //     const headers = new HttpHeaders({
    //   'Content-Type': 'application/json' // Set your desired headers
    // });

    // // Use params with HttpHeaders
    // const options = { headers: headers, responseType: 'blob' as 'json', params: yourParams };

  }

  blobPdf(url) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/pdf' // Set appropriate content type if known
    });

    return this.http.get(url, {
      headers: headers,
      responseType: 'blob'
    });
  }

  getImage() {
    return this.http.get(this.apiUrl + 'fleet/consumer/logo')
  }

  uploadImage(img) {
    let formdata = new FormData()
    formdata.append('file',img)
    return this.http.post(this.apiUrl + 'fleet/consumer/logo',formdata)
  }

  getProfile() {
    return this.http.get(this.apiUrl + 'fleet/profiling-default-value')
  }

  updateProfile(fleetId,body) {
    return this.http.put(this.apiUrl + 'fleet/profiling/'+fleetId,body)
  }

  addFord(id,pId) {
      let formdata = new FormData()
      formdata.append('fleetId',id)
      formdata.append('providerId',pId)
      return this.http.post(this.apiUrl + 'fleet/consent',formdata)
    
  }

   getManageList(page?, size?, vin?, consumer?, oem?, sortDate?, sortStatus?,fleetId?,vehicle?,reason?,inactiveForDays?,status?,action?,vins?,packageData?,vinSearch?,actionOn?,startDate?,endDate?) {
    let param = new HttpParams().set('page', page - 1).set('size', size)
    if (vin && !vinSearch) {
      param = param.append('vin', vin);
    }
    if (vinSearch) {
      param = param.append('vin', vinSearch);
    }
    if (consumer) {
      param = param.append('consumer', consumer);
    }
    if (oem) {
      param = param.append('provider', oem);
    }
    if (inactiveForDays) {
      param = param.append('inactiveForDays', inactiveForDays);
    }
    if (sortStatus) {
      param = param.append('sort', 'status,asc');
    }
    if (sortDate) {
      param = param.append('sort', 'creationDate,desc');
    }
    if(fleetId) {
      param = param.append('fleetId', fleetId);

    }
    if(vehicle && !vinSearch) {
      param = param.append('alias', vehicle);

    }
    if(reason) {
      param = param.append('failureReason', reason);

    }
    if(status) {
      param = param.append('enrollmentState', status);

    }
    if(action) {
      param = param.append('errorName', action);
    }
    if(actionOn) {
      param = param.append('actionOn', actionOn);
    }
    if(packageData) {
      param = param.append('packages', packageData);
    }
    if(startDate) {
      param = param.append('creationStartDate', startDate);
    }
    if(endDate) {
      param = param.append('creationEndDate', endDate);
    }
    const body = { vin: vins || [] }; 
    return this.http.post(this.authUrl + 'manage-vehicle/v2/enrollment',body, { params: param })
  }

  getAllProvidersAdmin(consumer?) {
    if (consumer) {
      return this.http.get(this.authUrl + `providers?consumer=${consumer}`)
    } else {
      return this.http.get(this.authUrl + 'providers')
    }
  }

  sendInvite(fleetId) {
    // let param = new HttpParams().set('fleetId',fleetId)
    return this.http.get(this.apiUrl + `fleet/send-email-template/${fleetId}`)
  }

    sendOEMMail(fleetId,oem) {
    let param = new HttpParams().set('provider',oem)
    return this.http.get(this.apiUrl + `fleet/send-add-oem-notification-mail-owner/${fleetId}`,{params:param})
  }

 getInactiveVIN(fleetId?,day?,page?,pageCount?,all?,provider?) {
    let url:any;
    let param = new HttpParams()
    if(all) {
     url=  'vehicle/dashboard/inactive-vins/all'
    } else {
  
      url = 'vehicle/dashboard/inactive-vins'
      param = param.append('page',page - 1)
      param = param.append('size',pageCount)
    }
      if(day) {
      param = param.append('days',day)      
    }
    if(fleetId) {
      param = param.append('fleetId',fleetId)
    }
    if(provider) {
      param = param.append('provider',provider)
    }
  
    return this.http.get(this.authUrl + url,{params:param})
  }
    uploadComment(vin,file,comment) {
    let formData= new FormData()
        formData.append('file',file)
        formData.append('comment',comment)
    return this.http.post(this.authUrl + `vehicle/dashboard/inactive-vins/${vin}/comment`,formData)
  }
}
